import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { log } from "console";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class MediaUpload {
  constructor(private http: HttpClient) {}

  // getImagePaths() {
  //   return this.http.get("/users/images");
  // }

  // storeImagePath(imagePath: string) {
  //   return this.http.post("/users/store-image", { imagePath });
  // }



  

  // private baseUrl = 'http://localhost:4000'; // base url
  // constructor(private http: HttpClient) {}

  // getImagePaths() {
  //   const url = `${this.baseUrl}/api/images`;
  //   return this.http.get(url);
  // }

  // storeImagePath(imagePath: string) {
  //   const url = `${this.baseUrl}/api/store-image`;
  //   return this.http.post(url, { imagePath });
  // }
}
